import { queryClient } from '@/shared/api/queryClient'
import { postToHost } from '@/shared/bridge/bridge'
import { usesHostSession } from '@/shared/bridge/env'
import { useAuthStore } from '@/shared/store/authStore'

export function logoutLocally(redirect = true) {
  const embedded = usesHostSession()
  useAuthStore.getState().logout()
  queryClient.clear()
  if (embedded) {
    postToHost({ type: 'LOGOUT' })
    return
  }
  if (redirect) window.location.href = '/login?reason=logout'
}
